<div class="app">
  <lotta-header></lotta-header>
  <div class="content">
    <router-outlet />
  </div>
  <lotta-footer></lotta-footer>
</div>